(function () {
  'use strict';

  angular.module('unit.info').factory('UnitInfo', UnitInfo);

  UnitInfo.$inject = ['$resource'];

  function UnitInfo($resource) {
    return $resource(
      '/api/unit',
      {},
      {
        get: { method: 'GET', url: '/api/unit/get/:id' },
        createProspect: { method: 'POST', url: '/api/prospect/create' },
        setFastDeal: { method: 'POST', url: '/api/unit/:id/fast_deal' },
      },
    );
  }
})();
